import { currentFeatures } from "@/configs/Settings";
import axios, { AxiosInstance } from "axios";

const useAxios: AxiosInstance = axios.create({
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    "X-Target-System": currentFeatures.defaultApp ? undefined : "vet",
  },
  timeout: 60000,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
});

useAxios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Adiciona interceptor de resposta para retry automático em caso de timeout
useAxios.interceptors.response.use(undefined, async (error) => {
  const config = error.config;

  // Verifica se o erro é um timeout (ECONNABORTED) e se não existe flag de retry
  if (error.code === "ECONNABORTED" && !config._retry) {
    config._retry = true;
    config.timeout = config.timeout * 1.5; // Aumenta o timeout em 50% para o retry
    console.warn(
      `Timeout na requisição para ${config.url}. Tentando novamente com timeout de ${config.timeout}ms`
    );
    return useAxios(config);
  }

  return Promise.reject(error);
});

export { useAxios };
